// Robust clipboard write — tries the async Clipboard API first and falls back
// to the legacy `document.execCommand('copy')` path when the async API throws
// (e.g. when the page is embedded and Permissions-Policy blocks clipboard write).
//
// Returns true on success, false otherwise. Never throws.

export async function copyTextToClipboard(text) {
    if (!text) return false;

    // 1. Modern async Clipboard API
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch {
        /* fall through to execCommand */
    }

    // 2. Fallback: hidden but in-viewport textarea + execCommand
    try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.top = "0";
        ta.style.left = "0";
        ta.style.width = "1px";
        ta.style.height = "1px";
        ta.style.padding = "0";
        ta.style.border = "0";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        const prevActive = document.activeElement;
        ta.focus();
        ta.select();
        ta.setSelectionRange(0, text.length);
        let ok = false;
        try {
            ok = document.execCommand("copy");
        } catch {
            ok = false;
        }
        document.body.removeChild(ta);
        if (prevActive && typeof prevActive.focus === "function") {
            try {
                prevActive.focus();
            } catch {
                /* noop */
            }
        }
        return ok;
    } catch {
        return false;
    }
}
